export const CONTRACTOR_SERVICES = [
  "Grass Cuts",
  "Small Repairs",
  "Trash Out",
  "Lock Changes",
  "Property Preservation",
  "Property Pictures",
  "Property Inspections",
  "Drywall Repairs",
  "Roof Repairs",
  "Plumbing",
  "Electrical",
];

export const WEBSITE_URL = "https://swiftsigningsandservices.com";
export const ONBOARDING_FORM_URL = "https://forms.gle/uuApWcKS1dvYWA729";
export const SUBCONTRACTOR_AGREEMENT_URL = "https://forms.gle/hiC4CoMhk56VmAdM8";
export const ONBOARDING_RESPONSES_URL = "https://docs.google.com/spreadsheets/d/e/2PACX-1vQwO2QOj_kFsltA_5K6TvzgylnSyhU8lTZqUaeX1OE3rzJSibmeOAGjdQG9DFA0l-kyrnVFWsvl5DVf/pub?output=csv";
export const ONBOARDING_WINDOW_DAYS = 30;

export function onboardingStatus(createdAt, completed) {
  if (completed) return { done: true, overdue: false, daysLeft: null, daysOver: 0 };
  if (!createdAt) return { done: false, overdue: false, daysLeft: ONBOARDING_WINDOW_DAYS, daysOver: 0 };
  const days = Math.floor((Date.now() - new Date(createdAt).getTime()) / 86400000);
  if (days >= ONBOARDING_WINDOW_DAYS) return { done: false, overdue: true, daysLeft: 0, daysOver: days - ONBOARDING_WINDOW_DAYS };
  return { done: false, overdue: false, daysLeft: ONBOARDING_WINDOW_DAYS - days, daysOver: 0 };
}

export async function shareApp() {
  const url = window.location.origin;
  try {
    if (navigator.share) await navigator.share({ title: "Swift Signings & Services", url });
    else await navigator.clipboard.writeText(url);
  } catch (e) {
    console.debug("Share dismissed:", e);
  }
}
